import { ActionIcon, Card, Table } from '@mantine/core';
import { getFetcher } from '@/api/fetchers';
import useSWR from 'swr';
import { IoMdDownload } from 'react-icons/io';
import { useParams } from 'react-router-dom';
import { type Audits } from '@/schemas/API/common/basic/audit';
import { useClientIPPFormContext } from '../ClientIppSection';
import dayjs from 'dayjs';
import { dateTimeFormatUI } from '@/index';
import { displayError } from '@/utils/error/errorHandler';
import { downloadFileWithBearerToken } from '@/utils/functions';
import React from 'react';

export const AuditModal: React.FC = () => {
  const { clientId } = useParams<{
    clientId: string;
  }>();
  const form = useClientIPPFormContext();
  const { data: audits } = useSWR<Audits>(
    `clients/${clientId}/careplans/${form.values.id}/audits`,
    getFetcher
  );

  const handleDownload = async (url: string) => {
    try {
      await downloadFileWithBearerToken(url);
    } catch (error) {
      displayError(error);
    }
  };

  const rows = audits?.content?.map((element, elementId) => (
    <Table.Tr key={elementId}>
      <Table.Td>{element.action}</Table.Td>
      <Table.Td>{element.by.firstName + ' ' + element.by.lastName}</Table.Td>
      <Table.Td>{dayjs(element.time).format(dateTimeFormatUI)}</Table.Td>
      <Table.Td>
        <ActionIcon
          variant="transparent"
          color="gray"
          onClick={async () => handleDownload(element.url)}
          data-testid={`download-icon-${elementId}`}
        >
          <IoMdDownload />
        </ActionIcon>
      </Table.Td>
    </Table.Tr>
  ));

  return (
    <Card>
      <Table>
        <Table.Thead>
          <Table.Tr>
            <Table.Th>Typ úpravy</Table.Th>
            <Table.Th>Vytvořil</Table.Th>
            <Table.Th>Datum</Table.Th>
            <Table.Th>PDF</Table.Th>
          </Table.Tr>
        </Table.Thead>
        <Table.Tbody>{rows}</Table.Tbody>
      </Table>
    </Card>
  );
};
